import { useState, useEffect, useRef } from "react";
import { SketchPicker } from "react-color";
import Draggable from "react-draggable";

export const WeatherModal = ({
  id,
  componentInfo,
  weatherData,
  deleteData,
  patchSettingsToBackend2,
  fetchWeather,
  componentName,
}) => {
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [settings, setSettings] = useState({});
  const [isDraggable, setIsDraggable] = useState(true);
  const [timeouts, setTimeouts] = useState({
    height: null,
    width: null,
    xPosition: null,
    yPosition: null,
    messageDelay: null,
    opacity: null,
    weatherTextColor: null,
    weatherTextSize: null,
    cityTextSize: null,
    dataTextSize: null,
    weatherImageSize: null,
    dataSize: null,
    zindex: null,
  });
  const nodeRef = useRef(null);

  useEffect(() => {
    if (componentInfo) {
      setSettings({
        backgroundColor: componentInfo.color,
        textColor: componentInfo.textColor,
        opacity: componentInfo.opacity || 0,
        width: componentInfo.width,
        height: componentInfo.height,
        xPosition: componentInfo.xPosition,
        yPosition: componentInfo.yPosition,
        weatherTextColor: componentInfo.weatherTextColor,
        weatherTextSize: componentInfo.weatherTextSize,
        cityTextSize: componentInfo.cityTextSize,
        dataTextSize: componentInfo.dataTextSize,
        weatherImageSize: componentInfo.weatherImageSize,
        dataSize: componentInfo.dataSize,
        weatherCity: componentInfo.weatherCity,
        zIndex: componentInfo.zIndex,
      });
    }
  }, [componentInfo]);

  const updateTimeout = (key, value) => {
    setTimeouts((prevTimeouts) => ({
      ...prevTimeouts,
      [key]: value,
    }));
  };

  useEffect(() => {
    return () => {
      Object.values(timeouts).forEach((timeout) => clearTimeout(timeout));
    };
  }, [timeouts]);

  const handleOnTextColorChange = (color) => {
    const newColor = color.hex;
    setSettings({ ...settings, textColor: newColor });
    patchSettingsToBackend2(
      {
        weatherTextColor: newColor,
      },
      weatherData.SettingsJson,
      id
    );
  };

  const handleOnBackgroundChange = (color) => {
    const newColor = color.hex;
    setSettings({ ...settings, color: newColor });
    patchSettingsToBackend2(
      {
        color: newColor,
      },
      weatherData.SettingsJson,
      id
    );
  };

  const handleSettingChange = (key, value) => {
    setSettings((prevSettings) => ({
      ...prevSettings,
      [key]: value,
    }));
    clearTimeout(timeouts[key]);
    updateTimeout(
      key,
      setTimeout(() => {
        patchSettingsToBackend2({ [key]: value }, weatherData.SettingsJson, id);
      }, 200)
    );
  };

  const handleSearch = () => {
    if (settings.weatherCity === "") {
      return;
    }

    patchSettingsToBackend2(
      {
        weatherCity: settings.weatherCity,
      },
      weatherData.SettingsJson,
      id
    );
    fetchWeather(settings.weatherCity);
  };

  const handleInputChange = (key, value, maxLimit) => {
    let parsedValue = parseInt(value, 10);
    if (isNaN(parsedValue)) {
      parsedValue = 2;
    } else if (parsedValue > maxLimit) {
      parsedValue = maxLimit;
    }
    handleSettingChange(key, parsedValue);
  };

  const handleKeyDown = (e) => {
    if (e.keyCode === 13) {
        const closeButton = document.querySelector(
          `#weatherModal${id} #weatherCity` 
        );
        closeButton.click();
    }
  };
  

  return (
    <Draggable nodeRef={nodeRef} disabled={!isDraggable}>
      <div
        className="modal"
        id={`weatherModal${id}`}
        tabIndex="-1"
        aria-labelledby={`weatherModal${id}`}
        aria-hidden="true"
        data-bs-backdrop="static"
        ref={nodeRef}
        onKeyDown={handleKeyDown}
      >
        <div className="modal-dialog">
          <div className="modal-content rounded-0">
            <div className="modal-header">
              <h4 className="modal-title fs-5" id={`weatherModal${id}`}>
                Properties for {componentName}
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div
              className="modal-body"
              onMouseEnter={() => setIsDraggable(false)}
              onMouseLeave={() => setIsDraggable(true)}
            >
              <>
                <ol className="list-group list-group-flush text-start">
                  <li className="list-group-item d-flex justify-content-between align-items-start">
                    <div className=" me-auto">Opacity</div>
                    <span className="me-2">{settings.opacity}%</span>
                    <span className="">
                      <input
                        type="range"
                        className="form-range"
                        min="0"
                        max="100"
                        step="25"
                        id="customRange3"
                        value={settings.opacity || 0}
                        onChange={(e) =>
                          handleSettingChange(
                            "opacity",
                            parseInt(e.target.value)
                          )
                        }
                      />
                    </span>
                  </li>

                  <li className="list-group-item d-flex justify-content-between align-items-start">
                    <div className="row w-100">
                      <div className="col input-group">
                        <span
                          className="input-group-text border-end-0"
                          id="width"
                        >
                          width
                        </span>
                        <input
                          name="width"
                          type="number"
                          className="form-control"
                          aria-label="width"
                          min={2}
                          max={24 - settings.xPosition || 0}
                          aria-describedby="width"
                          onChange={(e) =>
                            handleInputChange(
                              "width",
                              e.target.value,
                              24 - settings.xPosition
                            )
                          }
                          value={settings.width || ""}
                        />
                      </div>
                      <div className="col input-group">
                        <span className="input-group-text" id="height">
                          height
                        </span>
                        <input
                          name="height"
                          type="number"
                          min={2}
                          max={24 - settings.yPosition || 0}
                          className="form-control"
                          aria-label="Username"
                          aria-describedby="height"
                          onChange={(e) =>
                            handleInputChange(
                              "height",
                              e.target.value,
                              24 - settings.yPosition
                            )
                          }
                          value={settings.height || ""}
                        />
                      </div>
                    </div>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-start">
                    <div className="row w-100">
                      <div className="col input-group">
                        <span className="input-group-text" id="X">
                          X
                        </span>
                        <input
                          name="X"
                          type="number"
                          min={0}
                          max={24 - settings.width || 0}
                          className="form-control"
                          aria-label="X"
                          aria-describedby="X"
                          onChange={(e) =>
                            handleInputChange(
                              "xPosition",
                              e.target.value,
                              24 - settings.width
                            )
                          }
                          value={settings.xPosition || 0}
                        />
                      </div>
                      <div className="col input-group">
                        <span className="input-group-text border-end-0" id="Y">
                          Y
                        </span>
                        <input
                          name="Y"
                          type="number"
                          className="form-control"
                          aria-label="Y"
                          aria-describedby="Y"
                          min={0}
                          max={24 - settings.height || 0}
                          onChange={(e) =>
                            handleInputChange(
                              "yPosition",
                              e.target.value,
                              24 - settings.height
                            )
                          }
                          value={settings.yPosition || 0}
                        />
                      </div>
                    </div>
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <div className=" pt-1 me-auto">zIndex</div>
                    <input
                      name="textsizetop"
                      type="number"
                      className="form-control w-25 me-4"
                      value={settings.zIndex || 0}
                      onChange={(e) =>
                        handleSettingChange("zIndex", parseInt(e.target.value))
                      }
                    />
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <div className=" pt-1 me-auto">Temperature Text size</div>
                    <input
                      name="textsizeWeather1"
                      type="number"
                      className="form-control w-25 me-4"
                      value={settings.weatherTextSize || ""}
                      onChange={(e) =>
                        handleSettingChange(
                          "weatherTextSize",
                          parseInt(e.target.value)
                        )
                      }
                    />
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <div className=" pt-1 me-auto">City Text size</div>
                    <input
                      name="textsizeWeather2"
                      type="number"
                      className="form-control w-25 me-4"
                      value={settings.cityTextSize || ""}
                      onChange={(e) =>
                        handleSettingChange(
                          "cityTextSize",
                          parseInt(e.target.value)
                        )
                      }
                    />
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <div className=" pt-1 me-auto">Data size</div>
                    <input
                      name="textsizeWeather3"
                      type="number"
                      className="form-control w-25 me-4"
                      value={settings.dataSize || ""}
                      onChange={(e) =>
                        handleSettingChange(
                          "dataSize",
                          parseInt(e.target.value)
                        )
                      }
                    />
                  </li>
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <div className=" pt-1 me-auto">Data text size</div>
                    <input
                      name="textsizeWeather4"
                      type="number"
                      className="form-control w-25 me-4"
                      value={settings.dataTextSize || ""}
                      onChange={(e) =>
                        handleSettingChange(
                          "dataTextSize",
                          parseInt(e.target.value)
                        )
                      }
                    />
                  </li>

                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <div className="input-group mb-3">
                      <input
                        type="text"
                        className="form-control"
                        id={`cityInput ${id}`}
                        placeholder="search for city"
                        value={settings.weatherCity || ""}
                        //     onChange={(e) => setSettings(e.target.value)}
                        onChange={(e) =>
                          setSettings({
                            ...settings,
                            weatherCity: e.target.value,
                          })
                        }
                        aria-describedby="weatherCity"
                      />
                      <button
                      type="button"
                        className="input-group-text btn btn-success bg-success me-4"
                        id="weatherCity"
                        onClick={handleSearch}
                      >
                        Search
                      </button>
                    </div>
                  </li>
                </ol>
              </>
              <div className="accordion accordion-flush" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOneweather"
                      aria-expanded="true"
                      aria-controls="collapseOnweathere"
                    >
                      Background Color
                    </button>
                  </h2>
                  <div
                    id="collapseOneweather"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <SketchPicker
                        color={settings.backgroundColor}
                        onChangeComplete={handleOnBackgroundChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFourweather"
                      aria-expanded="true"
                      aria-controls="collapseFourweather"
                    >
                      Text Color
                    </button>
                  </h2>
                  <div
                    id="collapseFourweather"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <SketchPicker
                        color={settings.weatherTextColor}
                        onChangeComplete={handleOnTextColorChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              {deleteConfirmation ? (
                <>
                  <div>Are you sure ?</div>
                  <button
                    type="button"
                    className="btn btn-danger btn-sm rounded-0 "
                    onClick={deleteData}
                    data-bs-dismiss="modal"
                  >
                    YES
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm rounded-0"
                    onClick={() => setDeleteConfirmation(false)}
                  >
                    NO
                  </button>
                </>
              ) : (
                <>
                  <button
                    type="button"
                    className="btn btn-danger btn-sm rounded-0 "
                    onClick={() => setDeleteConfirmation(true)}
                  >
                    {" "}
                    REMOVE COMPONENT{" "}
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm rounded-0"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </Draggable>
  );
};
